import { getApiBaseUrl } from "./apiClient";
import { getToken as getAuthToken } from "@/utils/auth";

const API_BASE_URL = getApiBaseUrl();

export interface ReporteTextoParams {
  catalogo: 'Solicitudes' | 'Empresas' | 'Agendas';
  camposSolicitados: string;
  ownerID: string;
  fechaCriterio?: string;
  fechaInicio?: string;
  fechaFin?: string;
  filtroCriterio1?: string;
  filtroValor1?: string;
  filtroCriterio2?: string;
  filtroValor2?: string;
  filtroCriterio3?: string;
  filtroValor3?: string;
}

export const reporteTextoService = {
  async generarReporte(params: ReporteTextoParams): Promise<Blob> {
    const formData = new FormData();
    formData.append('catalogo', params.catalogo);
    formData.append('campos_solicitados', params.camposSolicitados);
    formData.append('owner_id', params.ownerID);
    
    if (params.fechaCriterio) formData.append('fecha_criterio', params.fechaCriterio);
    if (params.fechaInicio) formData.append('fecha_inicio', params.fechaInicio);
    if (params.fechaFin) formData.append('fecha_fin', params.fechaFin);
    if (params.filtroCriterio1) formData.append('filtro_criterio1', params.filtroCriterio1);
    if (params.filtroValor1) formData.append('filtro_valor1', params.filtroValor1);
    if (params.filtroCriterio2) formData.append('filtro_criterio2', params.filtroCriterio2);
    if (params.filtroValor2) formData.append('filtro_valor2', params.filtroValor2);
    if (params.filtroCriterio3) formData.append('filtro_criterio3', params.filtroCriterio3);
    if (params.filtroValor3) formData.append('filtro_valor3', params.filtroValor3);

    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/reportes/texto`, {
      method: 'POST',
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      credentials: 'include',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Error al generar reporte');
    }

    return await response.blob();
  },

  descargarCSV(blob: Blob, filename: string = 'ReporteTexto.csv'): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
